import api from '../../ApiConfig';
import { Apis } from '../../../config';
import { NotificationManager } from 'react-notifications';


const getWalletPackageAdd = async (data) => {
    try {
        let result = await api.post(Apis.GetWalletPackageAdd, data);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const getAllWalletPackageList = async () => {
    try {
        let result = await api.get(Apis.GetAllWalletPackageList);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const getWalletPackageUpdate = async (data) => {
    try {
        let result = await api.put(Apis.GetWalletPackageUpdate, data);
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

const getWalletPackageDelete = async (id) => {
    try {
        let result = await api.post(Apis.GetWalletPackageDelete, {
            id: id
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        return result.data;
    } catch (error) {
        console.log(error);
        return null;
    }
};

// services/GetWalletDetails.js
const getWalletTransactions = async (batch, search = "") => {
  try {
    const result = await api.get(Apis.GetWalletTransactions, {
      params: { batch, search },
    });

    if (result.errors) {
      NotificationManager.error(result.errors);
      return null;
    }

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const adminWalletTopup = async (data) => {
    try {
        const result = await api.post(Apis.adminWalletTopup, data);

        if (result.data && result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }

        return result.data;
    } catch (error) {
        console.log(error);
        NotificationManager.error("Server error");
        return null;
    }
};



export default {
    getWalletPackageAdd,
    getAllWalletPackageList,
    getWalletPackageUpdate,
    getWalletPackageDelete,
    getWalletTransactions,
    adminWalletTopup
};


// WEBPACK FOOTER //
// ./src/components/services/GetWalletDetails/index.js